// extracted by mini-css-extract-plugin
export default {"menu":"menu___Iz0aO","link":"link___yWkiZ","active":"active___Emz1T","arrow_right":"arrow_right___GK4eo"};